// ES
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Edición masiva",
    cfgTitle: "Configuración del calendario",
    syncSection: "Sincronización",
    resyncOta: "Re-sincronizar con OTA",
    resyncOtaSub: "Vuelve a empujar disponibilidad y tarifas al canal.",
  },
  mode: {
    calendar: "Calendario",
    rates: "Tarifas",
  },
  search: {
    placeholder: "Buscar huésped o código…",
    clear: "Limpiar",
    go: "Buscar",
    resultsHint: "{count} resultados — selecciona uno:",
    combo: "Combinada · {count} hab",
  },
  header: {
    occupancy: "Ocupación {pct}%",
  },
  type: {
    roomsAbbr: "hab",
    configTitle: "Configuración del tipo (OTA y reglas de llegada/salida)",
    otaConnected: "OTA conectada",
    subscribeToConnect: "Suscríbete para conectar OTAs",
  },
  rtCell: {
    editTooltip: "Clic para editar disponibilidad, precio, mínima y cierre",
    overbookRisk: "Riesgo de sobreventa",
    closedTag: "Cerrado",
  },
  rules: {
    sameDayCutoff: "Cierre de venta del mismo día a las {time}",
  },
  organizeRow: {
    title: "Por organizar",
    unplacedCount: "{count} reserva sin ubicar | {count} reservas sin ubicar",
    autoTooltip: "Reacomoda automáticamente las reservas entre habitaciones para que todas quepan",
    organizing: "Organizando…",
    organize: "Organizar",
  },
  footer: {
    available: "Disponible",
    unavailable: "No disponible",
    closed: "Cerrado",
    overbookRisk: "Riesgo de sobreventa",
    realtime: "Los valores se actualizan en tiempo real",
    timezone: "Zona horaria: {tz}",
  },
  dayEdit: {
    oneDay: "un día",
    open: "Abierto",
    closed: "Cerrado",
    priceLabel: "Precio · tarifa estándar",
    minStayLabel: "Estancia mínima (noches)",
    forSaleLabel: "Habitaciones a la venta",
    forSaleHint: "tope · máx {max}",
    applyMultiple: "¿Aplicar a varias fechas?",
    cancel: "Cancelar",
    saving: "Guardando…",
    save: "Guardar",
  },
  roomMenu: {
    create: "Crear reserva",
    createSub: "Reserva en el rango seleccionado",
    block: "Bloquear 1 habitación",
    blockSub: "Cierra esta habitación en el rango",
    unblock: "Quitar bloqueo",
    unblockSub: "Reabre esta habitación en el rango",
    oos: "Fuera de servicio",
    oosSub: "Mantenimiento de esta habitación",
  },
  closureMenu: {
    turnoverTitle: "Lo pone el tiempo de preparación",
    turnoverSub: "Se mueve solo con las fechas de la reserva y desaparece si se cancela.",
    changeRule: "Cambiar la regla",
    changeRuleSub: "Ajustar o desactivar el tiempo de preparación",
    editReason: "Modificar motivo",
    editReasonSub: "Cambiar la razón del bloqueo",
    changeRoom: "Cambiar de habitación",
    changeRoomSub: "Mover a otra habitación del tipo",
    unblock: "Quitar bloqueo",
    unblockSub: "Reabre y libera el espacio",
    moveTo: "Mover a…",
    noOtherRooms: "No hay otras habitaciones en este tipo.",
    barTooltip: "Bloqueo: {reason} — clic para modificar o quitar",
  },
  typeConfig: {
    seasons: "Temporadas de precio",
    seasonsSub: "Sube o baja el precio por fechas",
    manageOta: "Gestionar conexión OTA",
    connectOta: "Conectar OTA",
    otaSub: "Sincroniza el alojamiento con las OTAs",
    arrivalRules: "Reglas de llegada y salida",
    arrivalRulesSub: "Días permitidos de check-in / check-out",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Vendida por horas",
    soldOne: "Vendida por horas · {range}",
    soldMany: "Vendida por horas · {count} estancias",
  },
  tooltip: {
    past: "Pasada",
    unassignedHtml: "<strong>Sin habitación asignada.</strong> La disponibilidad está repartida entre habitaciones. Usa <strong>Organizar</strong> para reacomodarla automáticamente, o haz clic y asígnale una habitación.",
    nights: "{count} noche | {count} noches",
    guests: "{count} huésped | {count} huéspedes",
  },
  channels: {
    direct: "Directa",
  },
  syncModal: {
    title: "Sincronizar con la OTA",
    message: "Se recalculará y reenviará la disponibilidad y la estancia máxima de este calendario a la OTA.",
    confirm: "Sí, sincronizar",
    cancel: "Cancelar",
  },
  syncTooltip: {
    can: "Recalcula y reenvía a la OTA la disponibilidad y la estancia máxima (evita overbooking).",
    cannot: "Conecta la propiedad con un canal para poder sincronizar.",
  },
  block: {
    editTitle: "Modificar motivo",
    createTitle: "Bloquear habitación",
    reasonLabel: "Motivo del bloqueo",
    reasonHint: "(se mostrará en el calendario)",
    placeholder: "Ej: Mantenimiento, uso del propietario…",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveReason: "Guardar motivo",
    blockBtn: "Bloquear",
    defaultReason: "Bloqueado",
    thisRoom: "esta habitación",
    editReasonMsg: `Modificar el motivo del bloqueo de "{room}" ({count} noche). | Modificar el motivo del bloqueo de "{room}" ({count} noches).`,
    createMsg: `Se cerrará "{room}" ({unit}) durante {count} noche. No se podrá reservar en ella esas fechas; el resto de habitaciones del tipo siguen disponibles. | Se cerrará "{room}" ({unit}) durante {count} noches. No se podrá reservar en ella esas fechas; el resto de habitaciones del tipo siguen disponibles.`,
    presets: {
      maintenance: "Mantenimiento",
      ownerUse: "Uso del propietario",
      renovation: "Reforma",
      deepCleaning: "Limpieza profunda",
      externalReserved: "Reservado (externo)",
    },
  },
  organizeModal: {
    title: "Organizar automáticamente",
    bodyHtml: `Buscaremos el mejor acomodo y <strong>reorganizaremos las reservas entre las habitaciones</strong> de este tipo para que <strong>{count} reserva sin ubicar quepa</strong> de corrido. | Buscaremos el mejor acomodo y <strong>reorganizaremos las reservas entre las habitaciones</strong> de este tipo para que <strong>{count} reservas sin ubicar quepan</strong> de corrido.`,
    point1Html: "Solo cambia la <strong>habitación física</strong> asignada.",
    point2Html: "No se tocan <strong>fechas, precios ni huéspedes</strong>.",
    point3: "Si alguna no encaja de corrido, te avisamos.",
    cancel: "Cancelar",
    organizing: "Organizando…",
    confirm: "Sí, organizar",
  },
  empty: {
    noHotelTitle: "Sin anuncios de tipo hotel",
    noHotelSubHtml: "Crea un anuncio de tipo <strong>Hotel</strong> o <strong>Camping</strong> para comenzar a gestionar disponibilidad por habitaciones.",
    noHotelBtn: "Ir a anuncios",
    noRoomsTitle: "{name} no tiene habitaciones",
    noRoomsSub: "Este anuncio aún no tiene habitaciones registradas. Agrega habitaciones desde la configuración del anuncio para ver el calendario.",
    noRoomsBtn: "Configurar anuncio",
  },
  mock: {
    today: "Hoy",
    month: "MAYO DE 2026",
    searchPlaceholder: "Buscar por nombre o código…",
    searchBtn: "Buscar",
    createBtn: "Crear reserva",
    na: "N/D",
    forSaleLabel: "Disp. a la venta",
    suiteDeluxe: "Suite Deluxe",
    standardRoom: "Habitación Estándar",
    roomsCount2: "(2 hab.)",
    roomsCount3: "(3 hab.)",
    no: "No.",
    room101: "Habitación 101",
    room102: "Habitación 102",
    room201: "Habitación 201",
    room202: "Habitación 202",
    room203: "Habitación 203",
    d1: "lun 1",
    d2: "mar 2",
    d3: "mié 3",
    d4: "jue 4",
    d5: "vie 5",
    d6: "sáb 6",
    d7: "dom 7",
    d8: "lun 8",
    d9: "mar 9",
    d10: "mié 10",
    d11: "jue 11",
    d12: "vie 12",
  },
  ops: {
    closingDay: "Cerrando día…",
    openingDay: "Abriendo día…",
    saving: "Guardando…",
    movingBlock: "Moviendo bloqueo…",
    swappingBlockReservation: "Intercambiando bloqueo y reserva…",
    swappingReservationBlock: "Intercambiando reserva y bloqueo…",
    swappingRooms: "Intercambiando habitaciones…",
    changingRoom: "Cambiando de habitación…",
    organizingRooms: "Organizando habitaciones…",
    syncingWithOta: "Sincronizando calendario con la OTA…",
    processing: "Procesando…",
    settingMaintenance: "Poniendo en mantenimiento…",
    clearingMaintenance: "Quitando mantenimiento…",
    updatingAvailability: "Actualizando disponibilidad…",
    updatingReason: "Actualizando motivo…",
    closingRoom: "Cerrando habitación…",
    removingBlock: "Quitando bloqueo…",
  },
  toasts: {
    dayClosed: "Día cerrado",
    dayOpened: "Día abierto",
    availabilityUpdateErr: "No se pudo actualizar la disponibilidad",
    dayUpdated: "Día actualizado",
    daySaveErr: "No se pudo guardar el día",
    moveTargetMultipleReservations: "El destino tiene varias reservas en ese rango; muévelas manualmente.",
    roomRejectsBlock: "Esa habitación no admite el bloqueo en ese rango",
    blockMoved: "Bloqueo movido de habitación",
    blockMoveErr: "No se pudo mover el bloqueo",
    swapStartErr: "No se pudo iniciar el intercambio",
    reservationNoFitSwap: "La reserva no cabe en la otra habitación en todo su rango; no se pudo intercambiar.",
    reservationMoveErr: "No se pudo mover la reserva",
    swapCompleteErr: "No se pudo completar el intercambio (se revirtió)",
    blockReservationSwapped: "Bloqueo y reserva intercambiados",
    swapErr: "No se pudo intercambiar",
    rangeHasOccupiedOrClosed: "El rango incluye noches ocupadas o cerradas en esta habitación.",
    organizeErr: "No se pudo organizar automáticamente.",
    organizeNothing: "No había nada que reorganizar.",
    organizePartial: "Se organizaron {done} reserva(s), pero {unplaced} no cabe(n) de corrido en ninguna combinación.",
    organizeDoneAssigned: "Calendario organizado: {assigned} asignada(s)",
    organizeDoneMoved: ", {moved} movida(s) de habitación",
    swapGroupDone: "Intercambio en grupo completado: {groupCount} ⇄ {swappedCount} reservas.",
    roomsSwappedWith: "Habitaciones intercambiadas con {names}.",
    noPropertyToSync: "No hay propiedad para sincronizar.",
    calendarResynced: "Calendario recalculado y sincronizado con la OTA.",
    syncErr: "No se pudo sincronizar el calendario con la OTA.",
    genericError: "Error",
    reservationNoFitSwapStrict: "No se pudo intercambiar: la reserva no queda libre en todo su rango.",
    reservationBlockSwapped: "Reserva y bloqueo intercambiados",
    roomCloseErr: "No se pudo cerrar la habitación",
    reasonUpdated: "Motivo actualizado",
    roomClosedInRange: "Habitación cerrada en el rango",
    blockRemoved: "Bloqueo quitado",
    blockRemoveErr: "No se pudo quitar el bloqueo",
    searchMinChars: "Escribe al menos 2 caracteres para buscar",
    searchNoResults: "No se encontraron reservas para esa búsqueda",
    searchErr: "Error al buscar reservas",
  },
  summary: {
    stateAvailable: "Disponible",
    stateClosed: "Cerrado",
    stateNoDisp: "No disp.",
  },
};
